import { render, staticRenderFns } from "./index.vue?vue&type=template&id=506dcbfa&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('506dcbfa')) {
      api.createRecord('506dcbfa', component.options)
    } else {
      api.reload('506dcbfa', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=506dcbfa&", function () {
      api.rerender('506dcbfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/common-member/modules/form-filter/index.vue"
export default component.exports